import { render, staticRenderFns } from "./PayRangeCorrectedBadge.vue?vue&type=template&id=07dd58b5&scoped=true"
import script from "./PayRangeCorrectedBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeCorrectedBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeCorrectedBadge.vue?vue&type=style&index=0&id=07dd58b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd58b5",
  null
  
)

export default component.exports